import { ArrowTrendingUpIcon, LinkIcon } from "@heroicons/react/24/solid";
import { useProjectDetailsParams } from "../hooks/useProjectDetailsParams";
import { useDataLayer } from "data-layer";
import { useApplication } from "../../../projects/hooks/useApplication";
import { CartButtonToggle } from "./CartButtonToggle";
import { ProjectStats } from "./ProjectStats";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Sidebar(props) {
  const {
    chainId,
    roundId,
    applicationId
  } = useProjectDetailsParams();
  const dataLayer = useDataLayer();
  const {
    data: application
  } = useApplication({
    chainId: Number(chainId),
    roundId,
    applicationId: applicationId
  }, dataLayer);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "min-w-[320px] h-fit mb-6 rounded-3xl bg-gray-50",
      children: [/*#__PURE__*/_jsx(ProjectStats, {
        application: application
      }), props.isBeforeRoundEndDate && /*#__PURE__*/_jsx(CartButtonToggle, {
        isAlreadyInCart: props.isAlreadyInCart,
        addToCart: props.addToCart,
        removeFromCart: props.removeFromCart
      })]
    }), !props.isBeforeRoundEndDate && /*#__PURE__*/_jsxs("a", {
      href: `/#/projects/${application === null || application === void 0 ? void 0 : application.project.id}`,
      target: "_blank",
      className: "mt-4 flex font-bold justify-center border rounded-lg px-4 py-2",
      children: [/*#__PURE__*/_jsx(ArrowTrendingUpIcon, {
        className: "w-4 h-4 inline-block mt-1 mr-2"
      }), "View history", /*#__PURE__*/_jsx(LinkIcon, {
        className: "w-4 h-4 ml-2 mt-1"
      })]
    })]
  });
}